export default __webpack_public_path__ + "static/media/Cairo.9b6c5f38.jpg";